<template>
  <span
    class="inline-flex items-center justify-center w-6 h-6
      transition rounded-full bg-secondary-15 hover:bg-secondary-20 private-mode-button"
  >
    <aha-icon
      class="text-secondary-50 private-mode-icon"
      v-if="presentation.privateMode"
      name="lockv2"
      viewBox="0 0 14 20"
      width="18"
      height="18"
      v-tooltip="$i18nPresenter.t('Private: Audience cannot see or interact with your slides')"
    />

    <aha-icon
      class="text-secondary-50 private-mode-icon"
      v-else
      name="icon-multiple-language"
      viewBox="0 0 20 20"
      width="18"
      height="18"
      v-tooltip="$i18nPresenter.t('Public: Audience can see and interact with your slides')"
    />
  </span>
</template>
<script>
export default {
  name: 'PrivateModeButton',
  props: {
    presentation: {
      required: true,
      type: Object,
    },
  },
}
</script>
